function authHeader(){
    const baseHeader = {
        'Content-Type': 'application/json'       
    }

    const carParkInfo = JSON.parse(localStorage.getItem('carParkInfo') || '{}')

    if(carParkInfo && carParkInfo.guid){
        return { ...baseHeader, guid: carParkInfo.guid }
    }
    
    return baseHeader;
}

export default authHeader;